const l = (a) => {
  let e;
  return a < 1 ? e = 5.11916 * a ** 2 : e = 4.5 * Math.log(a + 1) + 2, (e / 100).toFixed(2);
};
export {
  l as default
};
